import React, {useMemo} from 'react'
import colors from '../../../utils/Colors'
import './styles.css'

const Progress = ({
                      size = 40,
                      percent = 0,
                      containerStyles = {},
                      stroke = colors.blue,
                      strokeWidth = 4,
                      bgStroke = colors.silverLite,
                  }) => {
    const radius = 20
    const circumference = 2 * Math.PI * radius
    const dashOffset = useMemo(() => circumference * (1 - percent / 100), [percent] )

    return (
        <div
            style={{
                width: size,
                height: size,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                ...containerStyles,
            }}
        >
            <svg
                viewBox="25 25 50 50"
                width={size}
                height={size}
                aria-hidden="true"
            >
                <circle
                    cx="50"
                    cy="50"
                    r={radius}
                    fill="none"
                    strokeWidth={strokeWidth}
                    stroke="currentColor"
                    style={{color: bgStroke}}
                />

                <circle
                    cx="50"
                    cy="50"
                    r={radius}
                    fill="none"
                    strokeWidth={strokeWidth}
                    stroke="currentColor"
                    strokeDasharray={circumference}
                    strokeDashoffset={dashOffset}
                    strokeLinecap="round"
                    style={{
                        color: stroke,
                        transformOrigin: '50% 50%',
                        transition: 'stroke-dashoffset 0.35s ease',
                    }}
                />
            </svg>
        </div>
    )
}

export default Progress



// WEBPACK FOOTER //
// ./src/components-new/ui/LoadingComponent/Progress.jsx